import React, { Component } from "react";
import KINTO_ICON from "../../../styles/images/brands/kinto.svg";

class Privacy extends Component {
  render() {
    return (
      <div id="privacy">
        <div className="header-kinto">
          <img
            className="brand-kinto"
            src={KINTO_ICON}
            name="Picture 1"
            align="bottom"
            border={0}
            alt="Acp"
          />
        </div>
        <br />
        <div>
          <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
            <font face="Toyota Text, serif">
              <font size={3} style={{ fontSize: "14pt" }}>
                <b>POLÍTICA DE PRIVACIDADE</b>
              </font>
            </font>
          </p>
          <br />
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                <b>ÂMBITO</b>
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Este texto contém a Política de Privacidade aplicável à
                plataforma KINTO CHARGE, disponível em{" "}
                <a href="https://webclient.go-KINTO.com/">
                  https://webclient.go-KINTO.com&nbsp;
                </a>
                e em versão app na Play Store e na App Store, tendo como
                objetivo informar o utilizador de acordo com as exigências do
                artigo 13º do Regulamento Geral de Proteção de Dados (“RGPD”).{" "}
              </font>
            </font>
          </p>
          <br />
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                <i>
                  <b>
                    Antes de fornecer os seus dados pessoais na plataforma KINTO
                    CHARGE e de aceitar os presentes Termos e Condições, deverá
                    ler com atenção a presente Política de Privacidade:
                  </b>
                </i>
              </font>
            </font>
          </p>
          <br />
          <ol>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <b>Responsável pelo tratamento</b>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
          >
            <font color="#000000">
              <font face="Calibri, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      A <b>KINTO PORTUGAL S.A. (doravante, “KINTO”),</b>
                    </font>
                  </font>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      com sede na Av. Vasco da Gama 780, 4430-247, Vila Nova de
                      Gaia, NIPC 502584866, com o capital social de € 75.000,00
                      €,{" "}
                    </font>
                  </font>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <u>
                        é a Responsável pelo Tratamento dos Dados Pessoais dos
                        utilizadores da plataforma KINTO CHARGE.{" "}
                      </u>
                    </font>
                  </font>
                </font>
              </font>
            </font>
          </p>
          <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>&nbsp;</p>
          <p
            align="justify"
            style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
          >
            <font color="#000000">
              <font face="Calibri, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      Nos casos em que, através da nossa plataforma, proceda à
                      celebração de um contrato para fornecimento de energia
                      elétrica na rede pública da MOBI.E, a{" "}
                    </font>
                  </font>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <b>EVIO – Electrical Mobility, Lda</b>
                    </font>
                  </font>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      .
                    </font>
                  </font>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <b>(doravante “EVIO”),</b>
                    </font>
                  </font>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      com sede na Av. D. Afonso Henriques, 1825, 4450-017
                      Matosinhos, na qualidade de&nbsp;Comercializador de
                      Energia Elétrica ("CEME) será também responsável pelo
                      tratamento dos seus dados. Esta entidade poderá também
                      proceder a recolhas autónomas dos seus dados diretamente
                      junto de si e ter a sua própria política de privacidade,
                      razão pela qual deverá contactar tal entidade em caso de
                      alteração ou questão relativa à utilização que aquela faz
                      dos seus dados. Em tais casos, a KINTO não terá qualquer
                      responsabilização ou intervenção.
                    </font>
                  </font>
                </font>
              </font>
            </font>
          </p>
          <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
            <br />
          </p>
          <ol start={2}>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <b>Base de licitude do tratamento</b>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
          >
            <font color="#000000">
              <font face="Calibri, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      Para efeitos da utilização da plataforma KINTO CHARGE e
                      para a disponibilização dos serviços aí descritos, a KINTO
                      necessita de recolher e tratar um conjunto de dados
                      pessoais, os quais, sendo essenciais à execução das
                      obrigações contratuais inerentes à prestação do serviço,
                      serão inseridos numa base de dados gerida pela KINTO.
                      Neste sentido,{" "}
                    </font>
                  </font>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <u>
                        os utilizadores da plataforma KINTO CHARGE fornecem os
                        seus dados preenchendo os campos obrigatórios dos
                        formulários aplicáveis, de forma a conseguir acesso às
                        funcionalidades da plataforma KINTO CHARGE
                      </u>
                    </font>
                  </font>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      . Para além dos dados pessoais necessários para a execução
                      das obrigações jurídicas do contrato e diligências
                      pré-contratuais a ele associadas,{" "}
                    </font>
                  </font>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <u>
                        a plataforma KINTO CHARGE também irá recolher e tratar
                        dados recorrendo a uma das seguintes condições de
                        licitude, sempre que seja efetivamente necessário
                      </u>
                    </font>
                  </font>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      :
                    </font>
                  </font>
                </font>
              </font>
            </font>
          </p>
          <ul>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
              >
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          cumprimento de obrigações jurídicas aplicáveis;
                        </font>
                      </font>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
              >
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          execução de um contrato ou de diligências
                          pré-contratuais a ele associadas;
                        </font>
                      </font>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
              >
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          interesse legítimo que o justifique, antecedido de um
                          juízo de ponderação do impacto do tratamento no
                          titular dos dados.{" "}
                        </font>
                      </font>
                    </font>
                  </font>
                </font>
              </p>
            </li>
          </ul>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Quando nenhuma das condições de licitude acima mencionadas for
                apta a suportar a operação de tratamento, a KINTO recorrerá ao
                consentimento livre e informado do titular dos dados pessoais.
              </font>
            </font>
          </p>
          <br />
          <ol start={3}>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <b>Finalidades do tratamento</b>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Quanto às finalidades do tratamento, a plataforma KINTO CHARGE
                tem por prioridade a prestação dos seus serviços como o apoio à
                mobilidade elétrica de com carregamento para veículos elétricos,
                entre outros. Para esse efeito, necessita de tratar dados
                pessoais, nomeadamente para:{" "}
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <br />
            <br />
          </p>
          <center>
            <table width={557} cellPadding={7} cellSpacing={0}>
              <colgroup>
                <col width={250} />
                <col width={278} />
              </colgroup>
              <tbody>
                <tr valign="top">
                  <td
                    width={250}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p align="center">
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>Finalidade</b>
                        </font>
                      </font>
                    </p>
                  </td>
                  <td
                    width={278}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p align="center">
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>Exemplos de atividades de tratamento</b>
                        </font>
                      </font>
                    </p>
                  </td>
                </tr>
                <tr valign="top">
                  <td
                    width={250}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p align="justify">
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>
                            Gestão de cliente, execução e cumprimento das nossas
                            obrigações pré-contratuais e contratuais
                          </b>
                        </font>
                      </font>
                    </p>
                  </td>
                  <td
                    width={278}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p style={{ marginBottom: "0cm" }}>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          Responder às suas solicitações e manter contacto
                          consigo por motivos administrativos e/ou operacionais,
                          assegurando que gerimos corretamente a sua relação
                          connosco e resolvemos a sua solicitação e/ou pedido.
                        </font>
                      </font>
                    </p>
                    <p>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          Executar os serviços constantes e referidos nos Termos
                          e Condições.
                        </font>
                      </font>
                    </p>
                  </td>
                </tr>
                <tr valign="top">
                  <td
                    width={250}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p align="justify">
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>Gestão do registo de utilizador</b>
                        </font>
                      </font>
                    </p>
                  </td>
                  <td
                    width={278}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          Caso se registe como utilizador da plataforma KINTO
                          CHARGE, necessitamos tratar os seus dados para o
                          identificar como utilizador registado e dar-lhe a
                          possibilidade de aceder às diversas funcionalidades,
                          produtos e serviços que estão ao dispor como
                          utilizador registado.
                        </font>
                      </font>
                    </p>
                  </td>
                </tr>
                <tr valign="top">
                  <td
                    width={250}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p align="justify">
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>
                            Análise e melhoria da funcionalidade e da qualidade
                            da plataforma KINTO CHARGE
                          </b>
                        </font>
                      </font>
                    </p>
                  </td>
                  <td
                    width={278}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p align="justify">
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          análise do grau de satisfação do utilizador tendo em
                          vista a implementação de melhorias à experiência do
                          utilizador e a prestação de um serviço com mais
                          qualidade. Trataremos os seus dados de navegação para
                          efeitos analíticos e estatísticos, para entender de
                          que forma os utilizadores interagem com a plataforma e
                          as ações que implementamos em outras páginas web e
                          apps, para que possamos melhorar os nossos serviços.
                          Além disso, realizaremos ocasionalmente inquéritos e
                          ações de qualidade destinados a conhecer o grau de
                          satisfação dos nossos utilizadores e a detetar as
                          áreas em que podemos melhorar;
                        </font>
                      </font>
                    </p>
                  </td>
                </tr>
                <tr valign="top">
                  <td
                    width={250}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p align="justify">
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>Combate à fraude</b>
                        </font>
                      </font>
                    </p>
                  </td>
                  <td
                    width={278}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          realizar as verificações necessárias para detetar e
                          prevenir possíveis fraudes ou utilizações fraudulentas
                          da plataforma KINTO CHARGE;
                        </font>
                      </font>
                    </p>
                  </td>
                </tr>
                <tr valign="top">
                  <td
                    width={250}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p align="justify">
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>Marketing</b>
                        </font>
                      </font>
                    </p>
                  </td>
                  <td
                    width={278}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          caso preste o seu consentimento expresso no campo
                          destinado ao efeito incluído no formulário de registo,
                          poderemos utilizar os seus dados pessoais para efeitos
                          de envio de informação publicitária e promocional da
                          KINTO;
                        </font>
                      </font>
                    </p>
                  </td>
                </tr>
                <tr valign="top">
                  <td
                    width={250}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p align="justify">
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>Apoio ao utilizador da plataforma KINTO CHARGE</b>
                        </font>
                      </font>
                    </p>
                  </td>
                  <td
                    width={278}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          responder aos pedidos ou questões que nos colocar
                          através dos diversos canais de contacto existentes,
                          incluindo para o exercício dos seus direitos enquanto
                          titular de dados pessoais;
                        </font>
                      </font>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    width={250}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p align="justify">
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>Gestão de Contencioso</b>
                        </font>
                      </font>
                    </p>
                  </td>
                  <td
                    width={278}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p>
                      &nbsp;
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          Cobrança judicial e extrajudicial e gestão de outros
                          conflitos (se aplicável)
                        </font>
                      </font>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    width={250}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p align="justify">
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>Gestão Contabilística, Fiscal e Administrativa</b>
                        </font>
                      </font>
                    </p>
                  </td>
                  <td
                    width={278}
                    style={{
                      border: "1px solid #000000",
                      padding: "0cm 0.19cm",
                    }}
                  >
                    <p>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          Contabilidade e faturação. Informação Fiscal,
                          incluindo envio de informação à Autoridade Tributária
                          (se aplicável).
                        </font>
                      </font>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </center>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                A plataforma KINTO CHARGE apenas tratará dados pessoais para as
                finalidades para as quais estes foram recolhidos, exceto quando
                considere que aqueles são necessários para outra finalidade,
                essa finalidade for compatível com a sua finalidade original
                (especialmente para fins de investigação científica ou
                histórica, ou para fins estatísticos), e sejam cumpridos os
                restantes requisitos impostos pela legislação de proteção de
                dados pessoais aplicáveis à reutilização de dados pessoais.
              </font>
            </font>
          </p>
          <br />
          <ol start={4}>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <b>Dados pessoais tratados</b>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Na qualidade de Responsável pelo Tratamento dos Dados Pessoais,
                a KINTO recolhe e trata os seguintes dados pessoais dos
                utilizadores da plataforma KINTO CHARGE, consoante o tipo de
                serviços prestado:{" "}
              </font>
            </font>
          </p>
          <br />
          <table width={566} cellPadding={7} cellSpacing={0}>
            <colgroup>
              <col width={268} />
              <col width={268} />
            </colgroup>
            <tbody>
              <tr valign="top">
                <td
                  width={268}
                  style={{ border: "1px solid #000000", padding: "0cm 0.19cm" }}
                >
                  <p align="center">
                    <font face="Toyota Text, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        <b>Categoria de dados</b>
                      </font>
                    </font>
                  </p>
                </td>
                <td
                  width={268}
                  style={{ border: "1px solid #000000", padding: "0cm 0.19cm" }}
                >
                  <p align="center">
                    <font face="Toyota Text, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        <b>Dados</b>
                      </font>
                    </font>
                  </p>
                </td>
              </tr>
              <tr valign="top">
                <td
                  width={268}
                  style={{ border: "1px solid #000000", padding: "0cm 0.19cm" }}
                >
                  <p align="justify">
                    <font face="Toyota Text, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        <b>Dados de identificação</b>
                      </font>
                    </font>
                  </p>
                </td>
                <td
                  width={268}
                  style={{ border: "1px solid #000000", padding: "0cm 0.19cm" }}
                >
                  <p align="justify">
                    <font face="Toyota Text, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        nome completo, NIF/NIPC, número de cartão de cidadão
                      </font>
                    </font>
                  </p>
                </td>
              </tr>
              <tr valign="top">
                <td
                  width={268}
                  style={{ border: "1px solid #000000", padding: "0cm 0.19cm" }}
                >
                  <p align="justify">
                    <font face="Toyota Text, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        <b>Dados de contacto</b>
                      </font>
                    </font>
                  </p>
                </td>
                <td
                  width={268}
                  style={{ border: "1px solid #000000", padding: "0cm 0.19cm" }}
                >
                  <p align="justify">
                    <font face="Toyota Text, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        Morada, telemóvel e email
                      </font>
                    </font>
                  </p>
                </td>
              </tr>
              <tr valign="top">
                <td
                  width={268}
                  style={{ border: "1px solid #000000", padding: "0cm 0.19cm" }}
                >
                  <p align="justify">
                    <font face="Toyota Text, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        <b>Dados de utilização da plataforma</b>
                      </font>
                    </font>
                  </p>
                </td>
                <td
                  width={268}
                  style={{ border: "1px solid #000000", padding: "0cm 0.19cm" }}
                >
                  <p align="justify">
                    <font face="Toyota Text, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        Login, password, número de registo, entre outros.
                      </font>
                    </font>
                  </p>
                </td>
              </tr>
              <tr valign="top">
                <td
                  width={268}
                  style={{ border: "1px solid #000000", padding: "0cm 0.19cm" }}
                >
                  <p align="justify">
                    <font face="Toyota Text, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        <b>Dados do veículo</b>
                      </font>
                    </font>
                  </p>
                </td>
                <td
                  width={268}
                  style={{ border: "1px solid #000000", padding: "0cm 0.19cm" }}
                >
                  <p align="justify">
                    <font face="Toyota Text, serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        Matrícula, dados de consumo, características e
                        localização para efeitos de identificação do posto de
                        carregamento do veículo, entre outros.
                      </font>
                    </font>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Sem prejuízo de outros dados devidamente especificados que lhe
                possam ser solicitados para os efeitos descritos na presente
                Política de Privacidade.
              </font>
            </font>
          </p>
          <br />
          <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Caso necessite de recorrer à funcionalidade “Contacte-nos’’, o
                Utilizador deverá indicar o motivo de contacto e enviar-nos a
                sua mensagem. Os únicos dados pessoais tratados serão os dados
                de identificação de utilizador da plataforma KINTO CHARGE e o
                eventual conteúdo da mensagem, por forma a podermos dar
                seguimento ao seu pedido.
              </font>
            </font>
          </p>
          <br />
          <ol start={5}>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <b>Proteção de dados desde a conceção e por defeito</b>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Nem todos os dados anteriormente referidos são obrigatoriamente
                tratados pela KINTO. Ao registar-se na plataforma, o Utilizador
                terá de fornecer obrigatoriamente apenas os seguintes dados:
                nome, número de telemóvel, e-mail e password.{" "}
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Quantos aos dados de localização, por defeito a funcionalidade
                de geolocalização está desligada. Cabe ao utilizador ativar a
                partilha da sua localização nas definições do seu dispositivo
                móvel e dar as permissões respetivas à aplicação KINTO CHARGE,
                sendo que esta apenas tratará os dados de localização para
                indicar ao Utilizador o(s) posto(s) de carregamento mais
                próximo(s) ou para o ajudar na definição de um trajeto. Em
                qualquer momento, o utilizador poderá desativar a funcionalidade
                da geolocalização, sem justificação necessária e sem quaisquer
                repercussões negativas. O Utilizador poderá aceitar receber
                notificações push através das definições do seu equipamento
                móvel. Do mesmo a KINTO poderá enviar comunicações ao utilizador
                via carta, e-mail, SMS e notificações push relativas às
                funcionalidades da plataforma KINTO CHARGE ou à alteração do seu
                funcionamento. Para usufruir de serviços adicionais e que
                envolvem pagamento, o Utilizador terá de inserir os dados
                referentes ao(s) seu(s) cartão(ões) de pagamento – número, data
                de validade e o Valor de Verificação de Cartão (CVV).{" "}
              </font>
            </font>
          </p>
          <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>&nbsp;</p>
          <ol start={6}>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <b>Prazo de conservação dos dados</b>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                De modo a garantir a conservação dos dados pessoais apenas pelo
                período de tempo necessário, a KINTO fixa prazos para o
                apagamento ou anonimização dos mesmos. Em determinados casos a
                conservação dos seus dados poderá ocorrer por períodos mais
                longos, nomeadamente quando a Lei assim o impuser ou para fins
                de investigação científica ou histórica ou para fins
                estatísticos.{" "}
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Os dados pessoais constantes do registo do utilizador, da
                utilização dos serviços da plataforma KINTO CHARGE são
                conservados durante a duração do contrato com o utilizador,
                enquanto que os dados de faturação serão armazenados de acordo
                com o prazo legal de 10 anos.{" "}
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Os dados pessoais tratados no âmbito de reclamações,
                solicitações, exercício de direitos e apoio ao utilizador são
                apenas conservados durante o tempo necessário para atender ao
                seu pedido e/ou responder à sua questão.
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Quanto aos dados pessoais tratados para marketing e ações de
                promoção dos serviços da KINTO, estes são apenas conservados
                enquanto o consentimento do titular para esta operação de
                tratamento for válido.
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Caso necessite de esclarecimentos adicionais sobre as medidas de
                segurança implementadas bem como sobre os prazos concretos de
                conservação dos dados, agradecemos contacto para o e-mail&nbsp;
                <a href="mailto:privacidade@kinto-mobility.pt">
                  privacidade@kinto-mobility.pt
                </a>
                .
              </font>
            </font>
          </p>
          <br />
          <ol start={7}>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <b>
                    Subcontratantes e comunicação dos dados a entidades
                    terceiras
                  </b>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            &nbsp;
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Os seus dados pessoais são tratados com a máxima
                confidencialidade e são utilizados única e exclusivamente para
                as finalidades identificadas.
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                A KINTO garante que nunca procederá à venda, empréstimo ou
                cedência dos seus dados pessoais a terceiros, sem que haja o seu
                expresso e explícito consentimento para o efeito.
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Conforme anteriormente referido, os seus dados pessoais serão
                partilhados com&nbsp;a{" "}
              </font>
            </font>
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                <b>EVIO – Electrical Mobility, Lda. (doravante “EVIO”),</b>
              </font>
            </font>
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                com sede na Av. D. Afonso Henriques, 1825, 4450-017 Matosinhos,
                na qualidade de&nbsp;Comercializador de Energia Elétrica
                ("CEME), na qualidade de responsável pelo tratamento dos seus
                dados no caso da celebração de um contrato de fornecimento de
                energia elétrica na rede pública da MOBI.E..
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Enquanto entidade responsável pelo desenvolvimento e manutenção
                da plataforma KINTO CHARGE, a EVIO terá também acesso aos seus
                dados pessoais, enquanto subcontratante da KINTO, sendo que a
                sua política de privacidade pode igualmente ser consultada
                em&nbsp;<a href="https://evio.pt/">https://evio.pt/</a>&nbsp;.
                <br />
                <br />
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Por outro lado, para garantirmos o devido seguimento às suas
                solicitações bem como lhe garantirmos a melhor assistência
                possível, os seus dados pessoais poderão ser partilhados com os
                nossos fornecedores ou prestadores de serviços, por exemplo:
              </font>
            </font>
          </p>
          <ul>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Instituições Financeiras
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Prestadores de serviços tecnológicos
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Prestadores de serviços relacionados com o apoio ao cliente.
                  </font>
                </font>
              </p>
            </li>
          </ul>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                A KINTO garante que todas as entidades referidas acima se
                encontram igualmente munidas de medidas técnicas e organizativas
                para garantir a total proteção dos seus dados pessoais e que os
                mesmos apenas tratarão dos seus dados para cumprimento integral
                das finalidades inerentes à execução do contrato.
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Caso os seus dados pessoais tenham que ser partilhados com
                entidades que não estejam localizadas no Espaço Económico
                Europeu, a KINTO garante que as mesmas se encontram obrigadas a
                respeitar a legislação europeia relativa à proteção de dados
                pessoais, nomeadamente através da celebração de acordos de
                transferências internacionais de dados com cláusulas contratuais
                tipo para o efeito.{" "}
              </font>
            </font>
          </p>
          <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Caso necessite de esclarecimentos adicionais sobre os concretos
                destinatários dos seus dados e as salvaguardas específicas que
                foram aplicadas à transferência dos seus dados, agradecemos
                contacto para o e-mail&nbsp;
                <a href="mailto:privacidade@kinto-mobility.pt">
                  privacidade@kinto-mobility.pt
                </a>
                .
              </font>
            </font>
          </p>
          <br />
          <ol start={8}>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <b>Medidas técnicas e organizativas</b>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                A segurança da informação e a proteção de dados pessoais são
                prioridades para a KINTO. Por esse motivo, tendo em vista o
                cumprimento dos artigos 24º e 32º do RGPD, a KINTO implementou
                um conjunto de medidas técnicas e organizativas que, tendo em
                conta as técnicas mais avançadas, os custos de aplicação, a
                natureza, o âmbito, o contexto e as finalidades de cada
                tratamento de dados pessoais, permitem mitigar os riscos para o
                titular dos dados pessoais e prevenir a ocorrência de violações
                de dados pessoais e de incidentes de segurança em geral. Em
                particular, destacam-se, entre outras, as seguintes medidas:
              </font>
            </font>
          </p>
          <ul>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Desenvolvimento dos esforços necessários para assegurar que
                    as entidades terceiras que colaboram com a KINTO garantem
                    uma proteção adequada dos dados pessoais a que tenham
                    acesso;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Limitação do acesso a dados pessoais a funcionários
                    específicos, e apenas quando o seu contacto com tais dados
                    pessoais se justifica, no âmbito das suas funções;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Armazenamento de todos os dados pessoais tratados pela KINTO
                    em servidores que oferecem garantias de segurança,
                    nomeadamente cifragem, controlo de acessos e realização de
                    backups;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Sujeição dos sistemas e políticas de segurança a análises
                    periódicas de forma a garantir que os dados estão seguros e
                    protegidos;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
              >
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Monitorização das infraestruturas tecnológicas da KINTO
                    tendo em vista a prevenção e deteção de irregularidades na
                    utilização das mesmas.
                  </font>
                </font>
              </p>
            </li>
          </ul>
          <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Sem prejuízo da implementação destas medidas, e na máxima
                extensão do permitido por Lei, a KINTO não poderá ser
                responsabilizada por atos de terceiros.
              </font>
            </font>
          </p>
          <br />
          <ol start={9}>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <b>Direitos dos titulares dos dados</b>
                </font>
              </p>
            </li>
          </ol>
          <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
            &nbsp;
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Tem o direito de, sempre que quiser e gratuitamente, pedir à
                KINTO para:
              </font>
            </font>
          </p>
          <ul>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Aceder aos dados que nos indicou;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Pedir a retificação dos seus dados;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Pedir o apagamento dos seus dados;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Pedir a limitação do tratamento dos seus dados;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Opor-se ao tratamento dos seus dados;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Solicitar a portabilidade dos seus dados para entidade por
                    si indicada.
                  </font>
                </font>
              </p>
            </li>
          </ul>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Se nos facultou o seu consentimento para o tratamento dos seus
                dados para qualquer finalidade, tem direito também a retirá-lo
                em qualquer momento, através das formas já referidas na presente
                Política de Privacidade.
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Para exercer qualquer um dos direitos referidos ou para qualquer
                esclarecimento adicional sobre o tratamento dos seus dados
                pessoais pela KINTO, basta enviar um e-mail para&nbsp;
                <a href="mailto:privacidade@kinto-mobility.pt">
                  privacidade@kinto-mobility.pt
                </a>
              </font>
            </font>
          </p>
          <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                <br />
                Se entender que não foram respeitados os seus direitos, poderá
                apresentar reclamação junto da Comissão Nacional de Proteção de
                Dados (CNPD):
              </font>
            </font>
          </p>
          <p
            style={{
              marginLeft: "1.25cm",
              marginBottom: "0.28cm",
              lineHeight: "0.64cm",
            }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Endereço: Av. D. Carlos I, 134 - 1.o, 1200-651 – Lisboa
              </font>
            </font>
          </p>
          <p
            style={{
              marginLeft: "1.25cm",
              marginBottom: "0.28cm",
              lineHeight: "0.64cm",
            }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Telefone: +351 213 928 400
              </font>
            </font>
          </p>
          <p
            style={{
              marginLeft: "1.25cm",
              marginBottom: "0.28cm",
              lineHeight: "0.64cm",
            }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Fax: +351 213 976 832
              </font>
            </font>
          </p>
          <p
            style={{
              marginLeft: "1.25cm",
              marginBottom: "0.28cm",
              lineHeight: "0.64cm",
            }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Endereço Eletrónico: geral@cnpd.pt
                <br />
              </font>
            </font>
            <br />
          </p>
          <ol start={10}>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <b>Cookies</b>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
          >
            <font color="#000000">
              <font face="Calibri, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      A plataforma KINTO CHARGE utiliza cookies para assegurar a
                      eficiência do seu funcionamento, para armazenar
                      informação, tais como as suas preferências pessoais quando
                      visita esta página e para melhorar o nosso serviço. Os
                      cookies são pequenos ficheiros de texto que são enviados
                      para o computador do utilizador (normalmente para o
                      browser deste) pelos sites visitados, sendo armazenados no
                      computador do utilizador para serem posteriormente
                      retransmitidos aos sites durante as ulteriores visitas do
                      utilizador aos mesmos. Isto poderá incluir um simples
                      pop-up, ou ligações em vários serviços que são
                      providenciados. O principal objetivo dos nossos cookies é
                      tornar a sua experiência de navegação mais cómoda e
                      eficiente. A informação recolhida nos cookies permite-nos
                      também melhorar a plataforma KINTO CHARGE através de
                      estimativas sobre dados estatísticos e padrões de
                      utilização (número de visitas, secções mais visitadas,
                      tempo de visita, etc.), conhecer estatisticamente o modo
                      como os utilizadores interagem com a plataforma KINTO
                      CHARGE para a melhoria dos nossos serviços, assim como a
                      adaptação da plataforma KINTO CHARGE aos seus interesses
                      individuais, a aceleração das pesquisas, etc. Em função do
                      seu proprietário, os cookies podem classificar-se em:{" "}
                    </font>
                  </font>
                </font>
              </font>
            </font>
          </p>
          <ul>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
              >
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          Cookies próprios: os que são enviados para o
                          computador ou dispositivo do utilizador a partir de um
                          equipamento ou domínio gerido pelo próprio editor e a
                          partir do qual se oferece a plataforma ou o serviço
                          solicitado pelo utilizador;{" "}
                        </font>
                      </font>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
              >
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          Cookies de terceiros: os que são enviados para o
                          computador ou dispositivo do utilizador a partir de um
                          equipamento ou domínio que não é gerido pelo editor,
                          mas por outra entidade que trata os dados obtidos
                          através dos cookies.{" "}
                        </font>
                      </font>
                    </font>
                  </font>
                </font>
              </p>
            </li>
          </ul>
          <p
            align="justify"
            style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
          >
            <br />
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
          >
            <font color="#000000">
              <font face="Calibri, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      Em função da sua finalidade, os cookies podem
                      classificar-se em:{" "}
                    </font>
                  </font>
                </font>
              </font>
            </font>
          </p>
          <ul>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
              >
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>Cookies estritamente necessários (técnicos</b>
                        </font>
                      </font>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          ): os que permitem ao utilizador a navegação através
                          de um site, plataforma ou aplicação e a utilização das
                          diferentes opções ou serviços que neles existam como,
                          por exemplo, controlar o tráfego, identificar dados ou
                          a sessão, aceder a secções ou conteúdos de acesso
                          restrito, recordar os elementos integrantes de uma
                          encomenda, fazer o processo de uma encomenda, gerir
                          pagamentos, controlar fraudes ligadas à segurança do
                          serviço, utilizar elementos de segurança durante a
                          navegação, solicitar a inscrição ou participação num
                          evento, armazenar conteúdos para a difusão de vídeos
                          ou som, habilitar conteúdos dinâmicos (por exemplo,
                          animação de carregamento de um texto ou imagem) ou
                          partilhar conteúdos através de redes sociais. Os
                          cookies técnicos, sendo estritamente necessários, são
                          descarregados, por defeito, quando permitem mostrar a
                          plataforma ou prestar o serviço solicitado pelo
                          utilizador;{" "}
                        </font>
                      </font>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
              >
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>Cookies de funcionalidade ou personalização</b>
                        </font>
                      </font>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          : os que permitem lembrar informação para que o
                          utilizador possa aceder ao serviço ou à plataforma com
                          determinadas características passíveis de diferenciar
                          a sua experiência da de outros utilizadores, como, por
                          exemplo, a língua, o número de resultados a mostrar
                          quando o utilizador faz uma pesquisa, o aspeto ou
                          conteúdo do serviço em função do tipo de navegador
                          usado pelo utilizador ou da região a partir da qual
                          acede ao serviço, etc. A não aceitação destes cookies
                          pode originar um desempenho lento do site ou
                          recomendações mal adaptadas;{" "}
                        </font>
                      </font>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
              >
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>Cookies de análise</b>
                        </font>
                      </font>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          : os que permitem quantificar o número de
                          utilizadores, as secções visitadas na plataforma e o
                          modo como interagem com a mesma, para assim realizar a
                          medição e análise estatística da utilização efetuada
                          pelos utilizadores, com o objetivo de introduzir
                          melhorias, em função da análise dos dados de
                          utilização dos utilizadores da plataforma ou serviço;{" "}
                        </font>
                      </font>
                    </font>
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
              >
                <font color="#000000">
                  <font face="Calibri, serif">
                    <font size={3} style={{ fontSize: "12pt" }}>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          <b>Cookies de publicidade comportamental</b>
                        </font>
                      </font>
                      <font face="Toyota Text, serif">
                        <font size={2} style={{ fontSize: "10pt" }}>
                          : os que armazenam informação do comportamento dos
                          utilizadores, obtida através da observação continuada
                          dos seus hábitos de navegação, o que permite
                          desenvolver um perfil específico para mostrar
                          publicidade em função do mesmo. Estes cookies permitem
                          a gestão, da forma mais eficaz possível, dos espaços
                          de publicidade que, se for o caso, tenham sido
                          incluídos diretamente pelo editor ou em colaboração
                          com terceiros.{" "}
                        </font>
                      </font>
                    </font>
                  </font>
                </font>
              </p>
            </li>
          </ul>
          <p
            align="justify"
            style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
          >
            <br />
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
          >
            <font color="#000000">
              <font face="Calibri, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      A informação armazenada nos cookies da plataforma KINTO
                      CHARGE é utilizada exclusivamente pela KINTO, com exceção
                      dos “cookies de terceiros”, que são utilizados e geridos
                      por entidades externas para nos prestarem serviços com o
                      propósito de melhorar os nossos serviços e a experiência
                      do utilizador ao navegar na plataforma KINTO CHARGE.{" "}
                    </font>
                  </font>
                </font>
              </font>
            </font>
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
          >
            <br />
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0cm", lineHeight: "0.64cm" }}
          >
            <font color="#000000">
              <font face="Calibri, serif">
                <font size={3} style={{ fontSize: "12pt" }}>
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      Caso necessite de esclarecimentos adicionais sobre as
                      definições e a nossa política de cookies, agradecemos
                      contacto para o e-mail &nbsp;
                      <a href="mailto:privacidade@kinto-mobility.pt">
                        privacidade@kinto-mobility.pt
                      </a>
                      .
                    </font>
                  </font>
                </font>
              </font>
            </font>
          </p>
          <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
            <br />
          </p>
          <ol start={11}>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <b>Perguntas e comentários</b>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                Caso tenha alguma dúvida ou questão sobre a forma como tratamos
                os seus dados pessoais, poderá contactar-nos e contactar o
                Encarregado de Proteção de Dados ("EPD”), através dos seguintes
                e-mails:
              </font>
            </font>
          </p>
          <ul>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Email:&nbsp;
                  </font>
                </font>
                <a href="mailto:privacidade@kinto-mobility.pt">
                  <font face="Toyota Text, serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      privacidade@kinto-mobility.pt
                    </font>
                  </font>
                </a>
              </p>
            </li>
          </ul>
          <ul>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <font size={2} style={{ fontSize: "10pt" }}>
                    Contacto do Encarregado de Proteção de Dados da KINTO:&nbsp;
                    <a href="mailto:epd@kinto-mobility.pt">
                      epd@kinto-mobility.pt
                    </a>
                    &nbsp;&nbsp;
                  </font>
                </font>
              </p>
            </li>
          </ul>
          <br />
          <ol start={12}>
            <li>
              <p style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}>
                <font face="Toyota Text, serif">
                  <b>Alterações à Política de Privacidade</b>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "0.64cm" }}
          >
            <font face="Toyota Text, serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                A &nbsp;KINTO reserva-se o direito de, a qualquer momento,
                proceder a modificações ou atualizações à presente Política de
                Privacidade, sendo essas alterações devidamente atualizadas na
                presente Plataforma.
              </font>
            </font>
          </p>
          <br />
        </div>
      </div>
    );
  }
}

export default Privacy;
